import type { ErrorTracker } from "./types";

// Used when telemetry is disabled (dev, tests, VITE_TELEMETRY_ENABLED=false).
// Every method is intentionally a no-op. Parameters are omitted (rather than
// declared-but-unused) to satisfy the ErrorTracker interface without unused-var lint errors.
export class NoopErrorTracker implements ErrorTracker {
  init(): void {
    // no-op
  }

  captureError(): void {
    // no-op
  }

  identify(): void {
    // no-op
  }

  reset(): void {
    // no-op
  }
}
